import { useQuery } from "@tanstack/react-query";
import { salesRecordKeys } from "apis/staff/query_keys_staff";
import { getMbshpSalesList } from "apis/staff/sales_record_api";
import { simpleAlert } from "components/CommonLib/CommonLib";
import { useDispatch } from "react-redux";

// [GET] 회원권 실적 리스트 검색
export const useMbshpSalesList = (queryData, enabled, setEnabled, setLoading) => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: salesRecordKeys.mbshpSalesList(queryData),
    queryFn: () => getMbshpSalesList(queryData),
    enabled: enabled,
    retry: false,
    cacheTime: 0,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
    onSettled: () => {
      setEnabled(false);
      setLoading(false);
    },
  });
};
